export enum SupportTicketStatusEnum {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  ANALYSIS_WAITING_CUSTOMER_APPROVAL = 'ANALYSIS_WAITING_CUSTOMER_APPROVAL',
  ANALYSIS_CUSTOMER_APPROVED = 'ANALYSIS_CUSTOMER_APPROVED',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED',
  REOPENED = 'REOPENED',
  CLOSED = 'CLOSED'
}
